<template>
	<div class="measure-temperature">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<div class="value"><span>{{ temperature }}</span> &deg;C</div>
		<d3-temperature :value="temperature"/>
	</div>
</template>

<script>
import D3Temperature from './D3Temperature'
export default {
	components: {
		D3Temperature
	},
	props: [
		'value'
	],
	computed: {
		temperature () {
			return this.value.values.last || 0
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/MeasureTemperature.vue